import React from 'react'

// Components
import TextDefault from 'components/flex/Text/TextDefault'
import TextWithImage from 'components/flex/Text/TextWithImage'
import TextWithImageLinks from 'components/flex/Text/TextWithImageLinks'
import TextWithLinks from 'components/flex/Text/TextWithLinks'
import TextImageGallery from 'components/flex/Text/TextImageGallery'
import TextIframeEmbed from 'components/flex/Text/TextIframeEmbed'

interface TextShellProps {
  fields: any
  location?: any
}

interface TextProps {
  [key: string]: any
}

function TextShell({ fields, location = {} }: TextShellProps) {
  const text: TextProps = {
    default: TextDefault,
    with_image: TextWithImage,
    with_images_links: TextWithImageLinks,
    links: TextWithLinks,
    image_gallery: TextImageGallery,
    iframe_embed: TextIframeEmbed,
  }

  if (!fields.styletype || !text[fields.styletype]) {
    return null
  }

  const Component = text[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default TextShell
